/**
 * Our user-state
 */
import React, {useEffect, useReducer} from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import REFRESH_AUTH_TOKEN from 'queries/mutations/refresh-auth.graphql';

// Context
const State = React.createContext();
const Dispatch = React.createContext();

// keys
const AUTH_KEY = 'auth';
const WOO_SESSION_KEY = 'woo-session';

// Reducer
const reducer = (state, action) => {
    let authData;

    switch (action.type) {
        case 'login':
            localStorage.setItem(AUTH_KEY, JSON.stringify(action.authData));
            localStorage.setItem(WOO_SESSION_KEY, action.authData.user?.sessionToken);

            return {
                isLoggedIn: true,
                authData: action.authData,
            };
        case 'logout':
            localStorage.removeItem(AUTH_KEY);
            localStorage.removeItem(WOO_SESSION_KEY);

            return {
                isLoggedIn: false,
                authData: null,
            };
        case 'refreshToken': {
            const updated = {
                ...JSON.parse(localStorage.getItem(AUTH_KEY)),
                authToken: action.authToken,
            };
            localStorage.setItem(AUTH_KEY, JSON.stringify(updated));

            return {
                isLoggedIn: true,
                authData: updated,
            };
        }
        default:
            return state;
    }
};

const Provider = ({children}) => {
    const [state, dispatch] = useReducer(
        reducer,
        {
            isLoggedIn: false,
            authData: null,
        },
    );

    const [refreshToken] = useMutation(REFRESH_AUTH_TOKEN, {
        context: {withAuth: true},
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            dispatch({type: data?.refreshJwtAuthToken?.authToken ? 'refreshToken' : 'logout', authToken: data?.refreshJwtAuthToken?.authToken});},
        onError: () => dispatch({type: 'logout'}),
    });

    useEffect(() => {
        let authData = localStorage.getItem(AUTH_KEY);

        if (authData) {
            authData = JSON.parse(authData);

            refreshToken({variables: {input: {jwtRefreshToken: authData?.authToken}}});
        }
    }, []);

    return (<State.Provider value={state}>
        <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </State.Provider>);
};

Provider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.elementType,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.arrayOf(PropTypes.elementType),
    ]),
};

// Export
export const User = {
    State,
    Dispatch,
    Provider,
};
